<ng-container
  *ngIf="{
    recordStatusCache: recordStatusCache$ | async
  } as data"
>
  <cng-table [tableDef]="tableDef" [pagination]="true">
    <!-- Caption -->
    <ng-container *cngCaptionDef>{{ 'history:viewInteractions.interactionList' | translate }}</ng-container>

    <!-- Filter -->
    <ng-container *cngTableFilterDef>
      <cng-input-filter [filterName]="Filter.FIRSTNAME" label="commons:basic.firstname"></cng-input-filter>
      <cng-input-filter [filterName]="Filter.LASTNAME" label="commons:basic.lastname"></cng-input-filter>
    </ng-container>
    <ng-container *cngTableFilterDef>
      <cng-input-filter [filterName]="Filter.URI" label="commons:popin.customer_card.address"></cng-input-filter>
      <cng-input-filter [filterName]="Filter.COMPANY_NAME" label="commons:popin.customer_card.company_name"></cng-input-filter>
    </ng-container>
    <ng-container *cngTableFilterDef>
      <cng-select-filter
        [filterName]="Filter.CHANNEL"
        label="history:viewInteractions.channel"
        [options]="channels$ | async"
        [unselect]="true"
      >
      </cng-select-filter>
      <cng-select-filter
        [filterName]="Filter.CAMPAIGN"
        label="history:viewInteractions.type"
        [options]="campaigns$ | async"
        [unselect]="true"
      >
      </cng-select-filter>
    </ng-container>
    <ng-container *cngTableFilterDef>
      <cng-select-filter [filterName]="Filter.CSR" label="commons:basic.agent" [options]="csrs$ | async" [unselect]="true">
      </cng-select-filter>
    </ng-container>
    <ng-container *cngTableFilterDef>
      <cng-datepicker-filter [filterName]="Filter.BEGIN_DATE" label="commons:basic.beginDate"> </cng-datepicker-filter>
      <cng-datepicker-filter [filterName]="Filter.END_DATE" label="commons:basic.endDate"></cng-datepicker-filter>
    </ng-container>

    <!-- Row actions -->>
    <cng-table-action-row
      *cngHasPermission="['HISTORIZATION::historization_interaction:update']"
      [action]="TableAction.EDIT"
      label="commons:actions.edit"
      icon="cng-ico_edit"
    >
    </cng-table-action-row>
    <cng-table-action-row
      *cngHasPermission="['HISTORIZATION::historization_interaction:read']"
      [action]="TableAction.CONSULT"
      label="commons:actions.consult"
      icon="cng-ico_search"
    >
    </cng-table-action-row>
    <cng-table-action-row
      *cngHasPermission="['HISTORIZATION::historization_interaction:listen']"
      [action]="TableAction.READ"
      label="commons:basic.listen"
      icon="cng-ico_enr"
      [hidden]="hasNotRecord.bind(this, data.recordStatusCache)"
      [disabled]="isRecordRestricted.bind(this, data.recordStatusCache)"
    >
    </cng-table-action-row>
  </cng-table>
  <cng-mediaplayer [playlist]="playlist" [currentAudio]="currentAudio" (currentAudioEvent)="onChangeAudio($event)"> </cng-mediaplayer>
</ng-container>
